// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SchemaMigrations_CheckResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/schema_migrations/check — the dry-run
 * (SchemaMigrator::status()): per model applied/pending + exact DDL, per
 * migration applied/pending by predicate. Reads only; success:false while
 * anything is pending.
 */
import type { SchemaMigrations_FailureRow } from './SchemaMigrations_FailureRow'
import type { SchemaMigrations_MigrationRow } from './SchemaMigrations_MigrationRow'
import type { SchemaMigrations_ModelRow } from './SchemaMigrations_ModelRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SchemaMigrations_CheckResponseDados {
outcome: string
total: number
pending: number
no_schema: number
models: SchemaMigrations_ModelRow[]
migrations: SchemaMigrations_MigrationRow[]
failures: SchemaMigrations_FailureRow[]
}

export type SchemaMigrations_CheckResponse = ApiResponse<SchemaMigrations_CheckResponseDados>;

registerResponseContract('SchemaMigrations_CheckResponse', {
  outcome:    { type: 'string',  required: true },
  total:      { type: 'number',  required: true },
  pending:    { type: 'number',  required: true },
  no_schema:  { type: 'number',  required: true },
  models: {
    type: 'array',
    required: true,
    items: {
      model:           { type: 'string',  required: true },
      state:           { type: 'string',  required: true },
      table:           { type: 'string',  required: false },
      ddl:             { type: 'string',  required: false },
      fields_hash:     { type: 'string',  required: false },
      last_applied_at: { type: 'string',  required: false },
      hash_changed:    { type: 'boolean', required: false },
    },
  },
  migrations: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'string',  required: true },
      description:     { type: 'string',  required: true },
      state:           { type: 'string',  required: true },
      last_applied_at: { type: 'string',  required: false },
      ledger_only:     { type: 'boolean', required: false },
    },
  },
  failures: {
    type: 'array',
    required: true,
    items: {
      model: { type: 'string',  required: true },
      error: { type: 'string',  required: true },
      phase: { type: 'string',  required: false },
    },
  },
})
